import React from 'react'

export default function AddCustomFieldHeader() {
    return (
        <div className="iv-header header-left-no-menu header-left">
            <div className="title-line">
                <div className="view-name">
                    <div className="ui5-title-app-name with-padding">Select field type</div>
                </div>
            </div>
        </div>
    );
}